var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 66.125C53.033 66.125 65.625 53.533 65.625 38C65.625 22.467 53.033 9.875 37.5 9.875C21.967 9.875 9.375 22.467 9.375 38C9.375 53.533 21.967 66.125 37.5 66.125Z",
    fill: "#5630B5",
    stroke: "#FBFBFB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125 38L34.375 44.25L46.875 31.75",
    fill: "#5630B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125 38L34.375 44.25L46.875 31.75",
    stroke: "#FBFBFB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.75b66e22ee42e47c99f586d861716b8d.svg";
export { ForwardRef as ReactComponent };